<template>
  <li class="guide-item">
    <div class="item-content">
      <p class="item-title">{{ guide.title }}</p>
      <div class="item-meta">
        <p class="item-date">{{ guide.date }}</p>
        <button @click="onEdit" class="edit-link">수정 하기</button>
      </div>
    </div>
    <button @click="onEdit" class="arrow-button">></button>
  </li>
</template>

<script>
export default {
  props: {
    guide: {
      type: Object,
      required: true,
    },
  },
  emits: ['edit'],
  setup(props, { emit }) {
    const onEdit = () => {
      emit('edit', props.guide.id);
    };

    return {
      onEdit,
    };
  },
};
</script>

<style scoped>
.guide-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 24px;
  gap: 20px;
  width: 100%;
  height: 48px;
  align-self: stretch;
}

.item-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex-grow: 1;
}

.item-title {
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.3px;
  color: #ECEFF1;
  margin: 0;
}

.item-meta {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  align-self: stretch;
}

.item-date {
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.3px;
  color: #ECEFF1;
  margin: 0;
}

.edit-link {
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.3px;
  text-decoration-line: underline;
  color: #ECEFF1;
}

.arrow-button {
  width: 24px;
  height: 24px;
  color: #B0BEC5;
}
</style>